import Script from 'next/script';
import style from './style.module.scss';
import Image from 'next/image';
import { Logo, Navigation } from '@/components';
import Link from 'next/link';
import { api } from '@/constants';
import { BurgerMenu } from '../burger-menu/burger/burger';
import { BurgerMenuWrapper } from '../burger-menu';

const getSocial = async () => {
  return api.contacts.getSocial();
};

export const Header = async () => {
  const response = await getSocial();

  if ('error' in response) {
    return <p>Ошибка</p>;
  }

  return (
    <header className={style.header}>
      {/* Подключаем Яндекс.Метрику через next/script */}
      <Script
        id="yandex-metrika"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            for (var j = 0; j < document.scripts.length; j++) {
              if (document.scripts[j].src === r) { return; }
            }
            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
            })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

            ym(99792302, "init", {
              clickmap:true,
              trackLinks:true,
              accurateTrackBounce:true,
              webvisor:true
            });
          `,
        }}
      />

      <noscript>
        <div>
          <img
            src="https://mc.yandex.ru/watch/99792302"
            style={{ position: 'absolute', left: '-9999px' }}
            alt=""
          />
        </div>
      </noscript>

      <div className="container">
        <div className={style.content}>
          <Logo isHeader={true} />

          <Navigation />

        </div>
      </div>
    </header>
  );
};
